 $(document).ready(function() {
     $('[data-option-index="1"]').find(".swatch__option").find('input').change(function() {
         if($('options-selection').find('[data-option-index="2"]').length) {
             $color_text = $(this).val();
             $selected_option = '';
           $selected_size = '';
            $selected_quantity = '';
            $size_available = false;
            //get the active size element firstly
            $selected_size = $('[data-option-index="0"]').find(".swatch__option").find("input:checked").attr("aria-label");
             if($selected_size != '' && $selected_size != undefined) {
                $(".variant-selection__variants").find("option:not(:first)").each(function() {
                    if($(this).attr("data-title").includes($color_text) &&
                        $(this).attr("data-title").includes($selected_size)) {
                       $selected_option = $(this).attr("data-title");
                         console.log("===============", $selected_option);
                         $selected_quantity = ($selected_option.split("/")[2]).trim();
                        $size_available = true;
                        return false; // breaks
                     }
                 });                
            }
             //
             if($size_available == false) {//if active size element is idle
                $(".variant-selection__variants").find("option:not(:first)").each(function() {
                     if($(this).attr("data-title").includes($color_text)) {
                         $selected_option = $(this).attr("data-title");
                        return false; // breaks
                    }
                });
                 $selected_size = ($selected_option.split("/")[0]).trim();
                 $selected_quantity = ($selected_option.split("/")[2]).trim();
            }            
            
             console.log($selected_size+"====/===="+$selected_quantity);
             var $size_available_element = $('[data-option-index="0"]').find('[value="'+$selected_size+'"]');
             $size_available_element.trigger('click');
            
            var $quantity_available_element = $('[data-option-index="2"]').find('[value="'+$selected_quantity+'"]');
             console.log($quantity_available_element.attr("class"));
             $quantity_available_element.trigger('click');
         }            
     });    
 });
